export default __webpack_public_path__ + "static/media/head5.f276369c.svg";